import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const colors = ['#fb7185', '#f472b6', '#facc15', '#38bdf8', '#34d399', '#a78bfa'];

const Confetti = () => {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    const generated = Array.from({ length: 60 }).map((_, index) => ({
      id: index,
      left: Math.random() * 100,
      size: 5 + Math.random() * 10,
      color: colors[Math.floor(Math.random() * colors.length)],
      duration: 3 + Math.random() * 5,
      delay: Math.random() * 2.5,
    }));
    setPieces(generated);
  }, []);

  return (
    <div className="birthday-confetti-layer">
      {pieces.map((piece) => (
        <motion.div
          key={piece.id}
          className="birthday-confetti-piece"
          style={{ left: `${piece.left}%`, width: `${piece.size}px`, height: `${piece.size}px`, background: piece.color }}
          animate={{ y: ['-10vh', '110vh'], rotate: [0, 360] }}
          transition={{ duration: piece.duration, delay: piece.delay, repeat: Infinity, ease: 'linear' }}
        />
      ))}
    </div>
  );
};

export default Confetti;
